
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DefaultRequestHeaderInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Clone the original request to create a new request object
    // This is necessary to avoid mutating the original request
    const newReq = request.clone({
      // Append headers to the cloned request
      headers: request.headers.append('Content-Type', 'application/json') // Set Content-Type to application/json
        .append('Accept', 'application/json'), // Set Accept header to application/json
    });

    // Pass the modified request to the next handler in the chain and return its observable
    return next.handle(newReq);
  }
}